<template>
  <v-form ref="form" v-model="valid">
    <alert-error :error="error"></alert-error>
    <v-row no-gutters>
      <v-col v-for="tag in tags" cols="6">
        <v-switch
          v-model="localUserTags"
          color="primary"
          :label="tag.name"
          :value="tag.id"
          dense
          hide-details
        ></v-switch>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <slot name="additional" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <slot name="buttons" :valid="valid" />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'TagForm',

  components: {
    AlertError: () => import('@/modules/_global/_components/AlertError')
  },

  model: {
    prop: 'userTags'
  },

  props: {
    userTags: {
      type: Array,
      required: true
    },
    tags: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    valid: true,
    localUserTags: [],
    error: null
  }),

  computed: {
    loading() {
      return this.$store.getters['loading'];
    }
  },

  watch: {
    localUserTags: {
      deep: true,
      handler: 'setUserTags'
    },
    userTags: {
      deep: true,
      handler: 'setLocalUserTags'
    },
    tags: {
      deep: true,
      handler: 'wtf'
    }
  },

  created() {},

  methods: {
    setUserTags(val) {
      this.$emit('input', Object.assign([], val));
    },
    wtf() {
      this.localUserTags = cloneDeep(this.userTags);
    },
    setLocalUserTags() {
      if (
        JSON.stringify(this.localUserTags) === JSON.stringify(this.userTags)
      ) {
        return;
      }
      this.localUserTags = cloneDeep(this.userTags);
    }
  }
};
</script>
